import { AxArtwork } from "@dynata/axiom3";
import unavailableImage from "@dynata/axiom3-images/png/general_stand.png";

export function AudiencesZeroState() {
    return (
        <AxArtwork
            title="No audiences"
            image={unavailableImage}
            description="Sorry, we could not match any Contexts with the provided search input. Please revise your search to continue."
        />
    )
}